import { HvlDateConverter, HvlMapConverter } from '@hvlng/framework-bff/util';
import { HvlBaseModel } from '@hvlng/framework-bff/core';
import { JsonObject, JsonProperty } from 'json2typescript';
import { EmptyControl, MaxLength, Required } from '@hvlng/framework-bff/core';
import { CountryModel } from 'infrastructure-shared';
import { CodeTextDiscriminatorModel, TextModel } from 'humanresources-common-shared';
import { PerObjectModel } from '../../../../../model/per-object-model';

@JsonObject('KovanHrPerObjectDefinitionModel')
export class PerObjectDefinitionModel extends HvlBaseModel {
    @Required()
    @JsonProperty('perObjectId', Number, true)
    perObjectId: number = null;

    @EmptyControl()
    @JsonProperty('perObject', PerObjectModel, true)
    perObject: PerObjectModel = new PerObjectModel();

    @EmptyControl()
    @JsonProperty('objectNumber', String, true)
    objectNumber: string = null;

    @Required()
    @JsonProperty('beginDate', HvlDateConverter, true)
    beginDate: Date = null;

    @Required()
    @JsonProperty('endDate', HvlDateConverter, true)
    endDate: Date = null;

    @EmptyControl()
    @JsonProperty('count', Number, true)
    count: number = null;

    @Required()
    @JsonProperty('objectStatusId', Number, true)
    objectStatusId: number = null;

    @EmptyControl()
    @JsonProperty('objectStatus', CodeTextDiscriminatorModel, true)
    objectStatus: CodeTextDiscriminatorModel = null;

    @EmptyControl()
    @JsonProperty('objectStatusText', String, true)
    objectStatusText: string = null;

    @EmptyControl()
    @JsonProperty('genCountryId', Number, true)
    genCountryId: number = null;

    @JsonProperty('genCountry', CountryModel, true)
    genCountry: CountryModel = new CountryModel();

    @EmptyControl()
    @JsonProperty('detailMap', HvlMapConverter, true)
    detailMap: Map<string, TextModel> = new Map<string, TextModel>();

    @MaxLength(50)
    @JsonProperty('shortText', String, true)
    shortText: string = null;

    @MaxLength(250)
    @JsonProperty('longText', String, true)
    longText: string = null;

    @MaxLength(50)
    @JsonProperty('objectCode', String, true)
    objectCode: string = null;

    @EmptyControl()
    @JsonProperty('versionId', Number, true)
    versionId: number = null;

    @MaxLength(50)
    @JsonProperty('code', String, true)
    code: string = null;

    @EmptyControl()
    @JsonProperty('active', Boolean, true)
    active: boolean = null;

    @EmptyControl()
    @JsonProperty('orgTypeGroup', [Number], true)
    orgTypeGroup: Array<number> = new Array<number>();

    @EmptyControl()
    @JsonProperty('path', String, true)
    path: string = null;

    @EmptyControl()
    @JsonProperty('managerNameSurname', String, true)
    managerNameSurname: string = null;
}
